import React from 'react';
import ReportsList from './Components/ReportsList/ReportsList';


const Legislation = () => {
	return (<ReportsList title={"pages.reports.legislation"} url={"/api/reports/legislation/"} />);
};

export default Legislation;
